import { EventOrWebinarType } from 'src/types/backendContent';
import { RegistryForm } from 'src/types/backendContent/RegistryForm';
import { Form, FormBaseProps, FormForEnum } from 'src/uikit/Form';

type RegistryFormProps = {
  form: RegistryForm;
  pageType: 'event' | 'webinar';
  eventTitle: string;
  eventSessionID?: string;
  markID: string;
  status: EventOrWebinarType['status'];
  isRegistrationClose?: boolean;
};

export function RegistryFormBlock(props: RegistryFormProps) {
  const {
    form,
    status,
    pageType,
    eventTitle,
    eventSessionID = '',
    markID,
    isRegistrationClose,
  } = props;

  if (status === 'STOP' || isRegistrationClose) {
    return null;
  }

  const isEvent = pageType === 'event';

  const formProps: FormBaseProps = {
    analyticsFieldFill: { formType: 'body' },
    agreementName: 'online_event_consent',
    marketingEventIDs: [markID],
    formVariant: 'inner',
    allFormsSentFormType: 'webinar',
    inputPath: isEvent ? 'v2/order' : 'v2/webinar_register',
    title: form.title,
    subtitle: form.description,
    buttonTitle: form.buttonTitle,
    formFor: FormForEnum.Registry,
    successfulSubmissonFormAnalytics: {
      formname: isEvent ? 'lead-events' : 'webinar-registration',
    },
    fields: form.fields,
    successNotice: {
      title: form.successText,
    },
    errorNotice: {
      title: form.failedText,
    },
  };

  return (
    <section id="form">
      <Form {...formProps} />
    </section>
  );
}
